import { MyLensesLensCtaText } from "../../gql-generated/types";
import { type Option } from "../../shared/models";

const websiteForbiddenOptions = new Set<MyLensesLensCtaText>([
    MyLensesLensCtaText.CtaTextDownload,
    MyLensesLensCtaText.CtaTextInstallNow,
    MyLensesLensCtaText.CtaTextOpenApp,
    MyLensesLensCtaText.CtaTextViewProfile,
]);

export const filterWebsiteOptions = (options: Option<MyLensesLensCtaText>[]): Option<MyLensesLensCtaText>[] =>
    options.filter((item) => !websiteForbiddenOptions.has(item.value));
